import React from 'react'

const MobilePaymentEligibility = ({ paymentmethod }) => {
  return (
    <>
      <p>
        {paymentmethod} supports payments in 36 countries and 22 currencies:
      </p>
      <ul>
        <li>
          <strong>Countries:</strong> Australia, Austria, Belgium, Bulgaria,
          Canada, China, Cyprus, Czech Republic, Denmark, Estonia, Finland,
          France, Germany, Greece, Hong Kong, Hungary, Ireland, Italy, Japan,
          Latvia, Liechtenstein, Lithuania, Luxembourg, Malta, Netherlands,
          Norway, Poland, Portugal, Romania, Singapore, Slovakia, Slovenia,
          Spain, Sweden, United States, United Kingdom
        </li>
        <li>
          <strong>Currencies:</strong> <code>AUD</code>, <code>BRL</code>,{' '}
          <code>CAD</code>, <code>CHF</code>, <code>CZK</code>, <code>DKK</code>
          , <code>EUR</code>, <code>GBP</code>, <code>HKD</code>,{' '}
          <code>HUF</code>, <code>ILS</code>, <code>JPY</code>, <code>MXN</code>
          , <code>NOK</code>, <code>NZD</code>, <code>PHP</code>,{' '}
          <code>PLN</code>, <code>SEK</code>, <code>SGD</code>, <code>THB</code>
          , <code>TWD</code>, <code>USD</code>
        </li>
      </ul>
    </>
  )
}

export default MobilePaymentEligibility
